var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Spinner',{attrs:{"status":_vm.showSpinner}}),_c('Alert',{attrs:{"i18nData":_vm.asyncError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }